"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketplaceEpics = exports.loadExchangeRatesEpic = exports.loadExchangeRateEpic = exports.loadExchangeProducts = exports.loadCampaignFiltersEpic = exports.loadFiltersEpic = exports.loadProductEpic = void 0;

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _queryString = _interopRequireDefault(require("query-string"));

var _marketplace = require("./marketplace.types");

var _marketplace2 = require("./marketplace.actions");

var loadProductEpic = function loadProductEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_marketplace.GIFT_CREATE_LOAD_PRODUCT_REQUEST), (0, _operators.debounceTime)(300), (0, _operators.mergeMap)(function (action) {
    return createGiftService.getProductDetails(action.payload.productId, action.payload.giftId).pipe((0, _operators.map)(function (response) {
      return (0, _marketplace2.loadProductSuccess)(response.product);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _marketplace2.loadProductFail
    })), (0, _operators.takeUntil)(action$.ofType(_marketplace.GIFT_CREATE_LOAD_PRODUCT_REQUEST)));
  }));
};

exports.loadProductEpic = loadProductEpic;

var loadFiltersEpic = function loadFiltersEpic(action$, state$, _ref2) {
  var createGiftService = _ref2.createGiftService,
      errorHandler = _ref2.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_marketplace.GIFT_CREATE_LOAD_MARKETPLACE_FILTERS_REQUEST), (0, _operators.debounceTime)(300), (0, _operators.mergeMap)(function (action) {
    return createGiftService.getMarketplaceFilters(action.payload).pipe((0, _operators.map)(function (response) {
      return (0, _marketplace2.loadFiltersSuccess)(response.options);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _marketplace2.loadFiltersFail
    })), (0, _operators.takeUntil)(action$.ofType(_marketplace.GIFT_CREATE_LOAD_MARKETPLACE_FILTERS_REQUEST)));
  }));
};

exports.loadFiltersEpic = loadFiltersEpic;

var loadCampaignFiltersEpic = function loadCampaignFiltersEpic(action$, state$, _ref3) {
  var createGiftService = _ref3.createGiftService,
      errorHandler = _ref3.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_marketplace.GIFT_CREATE_LOAD_CAMPAIGN_MARKETPLACE_FILTERS_REQUEST), (0, _operators.debounceTime)(300), (0, _operators.mergeMap)(function (action) {
    return createGiftService.getCampaignFilters(action.payload).pipe((0, _operators.map)(function (response) {
      return (0, _marketplace2.loadFiltersSuccess)(response.options);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _marketplace2.loadFiltersFail
    })), (0, _operators.takeUntil)(action$.ofType(_marketplace.GIFT_CREATE_LOAD_MARKETPLACE_FILTERS_REQUEST)));
  }));
};

exports.loadCampaignFiltersEpic = loadCampaignFiltersEpic;

var loadExchangeProducts = function loadExchangeProducts(action$, state$, _ref4) {
  var createGiftService = _ref4.createGiftService,
      errorHandler = _ref4.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_marketplace.GIFT_CREATE_LOAD_EXCHANGE_PRODUCTS_REQUEST), (0, _operators.debounceTime)(300), (0, _operators.mergeMap)(function (action) {
    return createGiftService.getExchangeProducts(action.payload.id, decodeURI(_queryString.default.stringify(action.payload.requestOptions, {
      arrayFormat: 'bracket'
    }))).pipe((0, _operators.map)(function (response) {
      return (0, _marketplace2.loadExchangeProductsSuccess)(response);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _marketplace2.loadExchangeProductsFail
    })), (0, _operators.takeUntil)(action$.ofType(_marketplace.GIFT_CREATE_LOAD_EXCHANGE_PRODUCTS_REQUEST)));
  }));
};

exports.loadExchangeProducts = loadExchangeProducts;

var loadExchangeRateEpic = function loadExchangeRateEpic(action$, state$, _ref5) {
  var createGiftService = _ref5.createGiftService,
      errorHandler = _ref5.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_marketplace.GIFT_CREATE_CALCULATE_EXCHANGE_REQUEST), (0, _operators.debounceTime)(300), (0, _operators.mergeMap)(function (_ref6) {
    var payload = _ref6.payload;
    return createGiftService.getExchangeRate(payload.fromCurrency, payload.toCurrency, payload.value).pipe((0, _operators.map)(function (response) {
      return (0, _marketplace2.loadExchangeRateSuccess)(response.data);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _marketplace2.loadExchangeRateFail
    })), (0, _operators.takeUntil)(action$.ofType(_marketplace.GIFT_CREATE_CALCULATE_EXCHANGE_REQUEST)));
  }));
};

exports.loadExchangeRateEpic = loadExchangeRateEpic;

var loadExchangeRatesEpic = function loadExchangeRatesEpic(action$, state$, _ref7) {
  var createGiftService = _ref7.createGiftService,
      errorHandler = _ref7.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_marketplace.GIFT_CREATE_CALCULATE_EXCHANGES_REQUEST), (0, _operators.debounceTime)(300), (0, _operators.mergeMap)(function (_ref8) {
    var payload = _ref8.payload;
    return createGiftService.getExchangeRates(payload).pipe((0, _operators.map)(function (response) {
      return (0, _marketplace2.loadExchangeRatesSuccess)(response.data);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _marketplace2.loadExchangeRatesFail
    })), (0, _operators.takeUntil)(action$.ofType(_marketplace.GIFT_CREATE_CALCULATE_EXCHANGES_REQUEST)));
  }));
};

exports.loadExchangeRatesEpic = loadExchangeRatesEpic;
var marketplaceEpics = [loadProductEpic, loadExchangeProducts, loadFiltersEpic, loadCampaignFiltersEpic, loadExchangeRateEpic, loadExchangeRatesEpic];
exports.marketplaceEpics = marketplaceEpics;